import { render, staticRenderFns } from "./product-benefits-card.vue?vue&type=template&id=237aa95a&scoped=true&"
import script from "./product-benefits-card.vue?vue&type=script&lang=js&"
export * from "./product-benefits-card.vue?vue&type=script&lang=js&"
import style0 from "./product-benefits-card.vue?vue&type=style&index=0&id=237aa95a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237aa95a",
  null
  
)

export default component.exports